import type { ZodObject, ZodRawShape } from 'zod';
import { z } from 'zod';
import { dateRangeSchema, yearAndPeriodSchema } from 'schemas/date.schema';

const allVariationsSchema = z.object({
  cluster: z.string({
    required_error: 'Please select a cluster',
    invalid_type_error: 'Please select a cluster'
  }),
  area: z.string({
    required_error: 'Please select an area',
    invalid_type_error: 'Please select an area'
  }),
  test: z.array(z.string()).nonempty({ message: 'Please select at least one test' })
});

export default function filterTopbarSchema(isSchool: boolean): ZodObject<ZodRawShape> {
  const schemaToReturn = allVariationsSchema;
  return isSchool
    ? schemaToReturn.merge(yearAndPeriodSchema)
    : schemaToReturn.merge(dateRangeSchema);
}
